//
//
//
//
//
//

import ReturnsAboveTheFold from '~/components/returns/Returns_AboveTheFold.vue';
import { metaData } from '~/configuration/metaData';

export default {
  name: 'Returns',
  head: {
    ...metaData.returns,
  },
  components: {
    ReturnsAboveTheFold,
  },
};
